<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <hm-col :id="$attrs['id']"
          :grid="true"
          :cols="`${compactMode ? '4 start-9' : '12'}`"
          class="grid--same-height">
    <card v-if="!compactMode" :title="$t('folios.transactionTransferView.card.charges')" cols="12 6@tablet" min-height="19rem">
      <hm-card-inner :full-size="true">
        <transfer-transaction-table :transactions="transactions" :parent-id="parentId" :folio-id="folioId" />
      </hm-card-inner>
    </card>

    <hm-col :cols="`${compactMode ? '12' : '12 6@tablet'}`" :grid="true" class="grid--row-gap">
      <tabable-card cols="12" min-height="19rem">
        <tabable-card-content :title="$t('folios.transactionTransferView.card.transferTarget')">
          <hm-card-inner>
            <hm-input-select v-model="target"
                             :disabled="relatedTargets === false"
                             :label="$t('folios.transactionTransferView.target')"
                             name="target"
                             cols="12 7@tablet"
                             rows="start-2@mobile">
              <template v-if="!isEmpty(transferTargets)">
                <option v-for="res in transferTargets.roomReservations" :value="res.id">{{ $t('folios.transactionTransferView.transferTargetRelatedReservation', { reservationNumber: res.number, arrivalDate: $options.filters.toDate(res.checkInDate), departureDate: $options.filters.toDate(res.checkOutDate), roomNumber: (isEmpty(res.roomNumber) ? '-' : res.roomNumber) }) }}</option>
              </template>
              <template v-if="!isEmpty(transferTargets) && hasLicense('GuestProfileFolios')">
                <option v-for="guest in transferTargets.guestProfiles" :value="guest.id">{{ `${displayName(guest)} (#${guest.number})` }}</option>
              </template>
            </hm-input-select>
            <hm-input-toggle v-model="relatedTargets" :label="$t('folios.transactionTransferView.relatedTargets')" cols="12 5@tablet" rows="start-1@mobile" />
          </hm-card-inner>
          <hm-card-inner v-if="!isNil(reservation)">
            <hm-select v-model="targetReservation"
                       :options="reservations"
                       :disabled="!otherReservation"
                       :label="$t('folios.transactionTransferView.targetReservation')"
                       :help="$t('folios.transactionTransferView.targetReservation_help')"
                       :label-expression="(args) => this.$t('folios.transactionTransferView.transferTargetSameDateReservation', { reservationNumber: args.option.reservationNumber, arrivalDate: args.toShortDate(args.option.checkInDate), departureDate: args.toShortDate(args.option.checkOutDate), roomNumber: args.option.roomNumber, statusText: args.option.statusText, displayName: args.option.displayName, sourceName: args.option.sourceName })"
                       name="targetReservation"
                       cols="12 7@tablet"
                       rows="start-1@mobile" />
            <hm-input-toggle v-model="otherReservation" :label="$t('folios.transactionTransferView.otherReservation')" cols="12 5@tablet" rows="start-1@mobile" />
          </hm-card-inner>
          <hm-card-inner v-if="hasLicense('GuestProfileFolios')">
            <guest-search :required="false"
                          v-model="targetGuestProfile"
                          :disabled="!otherGuestProfile"
                          :label="$t('folios.transactionTransferView.targetGuestProfile')"
                          cols="12 7@tablet"
                          rows="start-1@mobile" />
            <hm-input-toggle v-model="otherGuestProfile" :label="$t('folios.transactionTransferView.otherGuestProfile')" cols="12 5@tablet" rows="start-1@mobile" />
          </hm-card-inner>
        </tabable-card-content>
        <tabable-card-content :title="$t('folios.transactionTransferView.card.massTransfer')" @show="onShowMassTransfer">
          <hm-card-inner v-if="relatedTargets" :title="$t('folios.transactionTransferView.card.relatedSources')" full-size>
            <hm-col cols="12">
              <hm-table :hover="false"
                        columns="4"
                        grid-template-columns="max-content 7rem auto max-content"
                        min-width="500px"
                        display-last-line>
                <template v-for="res in transferTargets.roomReservations">
                  <template v-if="parentId !== res.id && !isEmpty(relatedTargetFolios[res.id])">
                    <div class="hm-table__td hm-table__td--has-child-rows cursor--pointer">
                      <hm-input-checkbox v-model="selectedMassTransferSources[res.id]"
                                         :label="`Res. #${res.number}`"
                                         style="margin-top:0.4rem;" />
                    </div>
                    <div class="hm-table__td hm-table__td--has-child-rows text--bold col-2 cursor--pointer" @click="toggleMassTransferSource(res.id)">{{ $t('folios.transactionTransferView.transferTargetRelatedReservation', { reservationNumber: res.number, arrivalDate: $options.filters.toDate(res.checkInDate), departureDate: $options.filters.toDate(res.checkOutDate), roomNumber: (isEmpty(res.roomNumber) ? '-' : res.roomNumber) }) }}</div>
                    <div class="hm-table__td hm-table__td--has-child-rows">&nbsp;</div>
                    <template v-for="(folio, idx) in relatedTargetFolios[res.id]">
                      <div :class="[{'hm-table__td--has-child-rows': (idx+1) < relatedTargetFolios[res.id].length}]" class="hm-table__td">&nbsp;</div>
                      <div :class="[{'hm-table__td--has-child-rows': (idx+1) < relatedTargetFolios[res.id].length}]" class="hm-table__td">#{{ folio.number + 1 }}</div>
                      <div :class="[{'hm-table__td--has-child-rows': (idx+1) < relatedTargetFolios[res.id].length}]" class="hm-table__td">{{ folio.address }}</div>
                      <div :class="[{'hm-table__td--has-child-rows': (idx+1) < relatedTargetFolios[res.id].length}, {'color--red': folio.balance < 0}]"
                           class="hm-table__td text-right">{{ folio.balance | toCurrency }} {{ hotelSettings.details.currency }}</div>
                    </template>
                  </template>
                </template>
                <template v-if="hasLicense('GuestProfileFolios')">
                  <template v-for="guest in transferTargets.guestProfiles">
                    <template v-if="parentId !== guest.id && !isEmpty(relatedTargetFolios[guest.id])">
                      <div class="hm-table__td hm-table__td--has-child-rows cursor--pointer">
                        <hm-input-checkbox v-model="selectedMassTransferSources[guest.id]"
                                           :label="`Guest. #${guest.number}`"
                                           style="margin-top:0.4rem;" />
                      </div>
                      <div class="hm-table__td hm-table__td--has-child-rows text--bold col-2 cursor--pointer" @click="toggleMassTransferSource(guest.id)">{{ `${displayName(guest)} (#${guest.number})` }}</div>
                      <div class="hm-table__td hm-table__td--has-child-rows">&nbsp;</div>
                      <template v-for="(folio, idx) in relatedTargetFolios[guest.id]">
                        <div :class="[{'hm-table__td--has-child-rows': (idx+1) < relatedTargetFolios[guest.id].length}]" class="hm-table__td">&nbsp;</div>
                        <div :class="[{'hm-table__td--has-child-rows': (idx+1) < relatedTargetFolios[guest.id].length}]" class="hm-table__td">#{{ folio.number + 1 }}</div>
                        <div :class="[{'hm-table__td--has-child-rows': (idx+1) < relatedTargetFolios[guest.id].length}]" class="hm-table__td">{{ folio.address }}</div>
                        <div :class="[{'hm-table__td--has-child-rows': (idx+1) < relatedTargetFolios[guest.id].length}, {'color--red': folio.balance < 0}]"
                             class="hm-table__td text-right">{{ folio.balance | toCurrency }} {{ hotelSettings.details.currency }}</div>
                      </template>
                    </template>
                  </template>
                </template>
              </hm-table>
            </hm-col>
            <hm-col cols="12" style="padding: 0.8rem 1.5rem 0 1.5rem">
              <hm-button :disabled="Object.values(selectedMassTransferSources).filter(it => it).length <= 0"
                         class="btn--orange"
                         cols="12"
                         icon-left="back-2c"
                         @click="transferInMultiple">{{ $t('folios.transactionTransferView.card.pullTransactions') }}</hm-button>
            </hm-col>
          </hm-card-inner>
        </tabable-card-content>
      </tabable-card>
      <template v-if="folioTarget">
        <card :title="`${$t('folios.transactionTransferView.card.transferTarget')} // ${$t(`folio.title.${folioTarget.includes('::res::') ? 'RoomReservation' : 'GuestProfile'}`, [$options.filters.id2number(folioTarget)])}`" cols="12">
          <hm-card-inner :full-size="true">
            <transfer-folio-table v-if="!isNil(folioTarget)"
                                  :folios="filteredTargetFolios"
                                  :folio-id="folioId"
                                  :parent-id="folioTarget"
                                  :items-per-page="5"
                                  @transferin="transferIn"
                                  @transferred="updateFolios" />
            <transfer-overlay />
          </hm-card-inner>
        </card>
      </template>
    </hm-col>
  </hm-col>
</template>

<script>

import HotelmeisterMixin from '@/mixins/HotelmeisterMixin';
import {
  isArray,
  join,
  isNil,
  isEmpty,
  groupBy,
  values,
  head,
  cloneDeep,
  concat,
  unionBy,
  reverse,
  sortBy,
  last,
  take,
} from 'lodash';
import TransactionTable from '../table/TransactionTable';
import FolioTable from '../table/FolioTable';
import TransferOverlay from './TransferOverlay';
import HotelSettingsMixin from '../../../mixins/HotelSettingsMixin';
import HmCardInner from '../layout/HmCardInner';
import HmButton from '../buttons/HmButton';
import TabableCard from '../layout/TabableCard';
import TabableCardContent from '../layout/TabableCardContent';

export default {
  name: 'TransferTransactionView',
  components: { TabableCardContent, TabableCard, HmButton, HmCardInner, TransferOverlay, FolioTable },
  mixins: [HotelmeisterMixin, HotelSettingsMixin],

  props: {
    transactions: {
      type: Array,
      required: true,
      default: () => [],
    },
    parentId: {
      type: String,
      required: false,
      default: null,
    },
    folioId: {
      type: String,
      required: false,
      default: null,
    },
    draggable: {
      type: Boolean,
      required: false,
      default: true,
    },
    folios: {
      type: Array,
      required: true,
      default: () => [],
    },
    reservation: {
      type: Object,
      required: false,
      default: null,
    },
  },

  data: function () {
    return {
      selectedMassTransferSources: {},
      relatedTargetFolios: {},
      transferTargets: [],
      target: this.parentId,
      targetGuestProfile: null,
      targetReservation: null,
      targetFolios: this.folios,
      relatedTargets: true,
      otherReservation: false,
      otherGuestProfile: false,
      reservations: [],
    };
  },

  computed: {
    compactMode: function () {
      return this.$store.getters['layout/activeBreakpoint'] === 'hd';
    },
    filteredTargetFolios: function () {
      return this.targetFolios.filter(folio => folio.locked !== true && isEmpty(folio.invoiceNumber) && folio.id !== this.folioId);
    },
    folioTarget: function () {
      if (this.relatedTargets) {
        return this.target;
      } else if (this.otherReservation) {
        return this.targetReservation;
      } else if (this.otherGuestProfile) {
        return this.targetGuestProfile;
      } else {
        return null;
      }
    },
  },

  watch: {
    target: function () {
      if (this.target === null) {
        this.transferTargets = [];
      } else {
        this.updateFolios();
      }
    },
    relatedTargets: function (newVal) {
      if (newVal === false) {
        if (this.otherGuestProfile === false && this.otherReservation === false) {
          this.$nextTick(() => {
            this.relatedTargets = true;
          });
        }
      } else {
        this.targetFolios = this.folios;
        this.otherGuestProfile = false;
        this.otherReservation = false;
        this.updateFolios();
      }
    },
    otherGuestProfile: function (newVal) {
      if (newVal === false) {
        if (this.relatedTargets === false && this.otherReservation === false) {
          this.relatedTargets = true;
        }
      } else {
        this.targetFolios = [];
        this.relatedTargets = false;
        this.otherReservation = false;
        this.updateFolios();
      }
    },
    otherReservation: function (newVal) {
      if (newVal === false) {
        if (this.otherGuestProfile === false && this.relatedTargets === false) {
          this.relatedTargets = true;
        }
      } else {
        this.targetFolios = [];
        this.otherGuestProfile = false;
        this.relatedTargets = false;
        if (isEmpty(this.reservations)) this.updateReservations();
        this.updateFolios();
      }
    },
    targetGuestProfile: function () {
      this.updateFolios();
    },
    targetReservation: function () {
      this.updateFolios();
    },
  },

  created: function () {
    this.updateTargets();

    this.$serviceBus.$on('folio.list', (data) => {
      if (data.data.parent.id === this.target) {
        this.targetFolios = data.data.folios;
      }
    });
  },

  methods: {
    displayName: function (guest) {
      return [
        guest.companyName,
        [
          guest.namePrefix,
          this.hotelSettings.details.roomPlanLastNameFirst === true ? guest.lastName : guest.firstName,
          guest.middleName,
          this.hotelSettings.details.roomPlanLastNameFirst === true ? guest.firstName : guest.lastName,
          guest.nameSuffix,
        ]
          .filter(it => !isEmpty(it))
          .join(' '),
      ]
        .filter(it => !isEmpty(it))
        .join(' / ');
    },
    updateTargets() {
      this.axios.get(this.serviceUrls.folio.transferTargets(this, this.parentId, this.folioId))
        .then((response) => {
          this.transferTargets = response.data.data;
        });
    },
    updateFolios() {
      if (this.relatedTargets === true) {
        this.axios.get(this.serviceUrls.folio.list(this, this.target))
          .then((response) => {
            this.targetFolios = response.data.data.folios;
          });
      } else if (this.otherGuestProfile === true && !isEmpty(this.targetGuestProfile)) {
        this.axios.get(this.serviceUrls.folio.list(this, this.targetGuestProfile))
          .then((response) => {
            this.targetFolios = response.data.data.folios;
          });
      } else if (this.otherReservation === true && !isEmpty(this.targetReservation)) {
        this.axios.get(this.serviceUrls.folio.list(this, this.targetReservation))
          .then((response) => {
            this.targetFolios = response.data.data.folios;
          });
      } else {
        this.targetFolios = [];
      }
    },
    updateReservations: function () {
      this.axios.get(this.serviceUrl('reservation.find'), {
        params: {
          q: null,
          from: this.reservation.checkInDate,
          until: this.reservation.checkOutDate,
          status: null,
        },
      })
        .then((response) => {
          this.reservations = response.data.data.filter(it => it.status !== 'CreationFailed');
          this.reservations.forEach((it) => {
            it.statusText = this.$t(`ReservationStatus.${it.status}`);
          });
        });
    },
    transferIn(transferSource) {
      if (this.$store.getters['save/saveInProgress']) return;

      this.$store.commit('save/started', this.folioId);
      this.axios.put(this.serviceUrls.folio.transferTransactionIn(this, this.parentId, this.folioId), transferSource)
        .then((response) => {
          this.$serviceBus.$emit('folio.reload');
          this.updateFolios();
          this.showSuccessMessage();
        })
        .catch((error) => {
          this.showMessages(error.response);
        })
        .finally(() => {
          this.$store.commit('save/finished', this.folioId);
        });
    },
    transferInMultiple() {
      if (this.$store.getters['save/saveInProgress']) return;

      this.$store.commit('save/started', this.folioId);
      const param = Object.entries(this.selectedMassTransferSources).filter(it => it[1]).map(it => it[0]);
      this.axios.put(this.serviceUrls.folio.transferTransactionInMultiple(this, this.parentId, this.folioId), { parentIds: param })
        .then((response) => {
          this.$serviceBus.$emit('folio.reload');
          this.updateFolios();
          this.showSuccessMessage();
          this.selectedMassTransferSources = {};
        })
        .catch((error) => {
          this.showMessages(error.response);
        })
        .finally(() => {
          this.$store.commit('save/finished', this.folioId);
          this.updateMassTransferTargets();
        });
    },
    onShowMassTransfer() {
      this.updateMassTransferTargets();
    },
    toggleMassTransferSource(parentId) {
      if (parentId in this.selectedMassTransferSources) this.selectedMassTransferSources[parentId] = !this.selectedMassTransferSources[parentId];
      else this.$set(this.selectedMassTransferSources, parentId, true);
    },
    updateMassTransferTargets() {
      this.relatedTargets = true;
      this.selectedMassTransferSources = {};
      this.relatedTargetFolios = {};
      take(this.transferTargets.roomReservations, 25).forEach((it) => {
        this.axios.get(this.serviceUrls.folio.list(this, it.id))
          .then((response) => {
            this.$set(
              this.relatedTargetFolios,
              it.id,
              response.data.data.folios.filter(folio => folio.locked !== true && isEmpty(folio.invoiceNumber) && folio.id !== this.folioId && folio.hasOpenTransactions),
            );
          });
      });
      take(this.transferTargets.guestProfiles, 10).forEach((it) => {
        this.axios.get(this.serviceUrls.folio.list(this, it.id))
          .then((response) => {
            this.$set(
              this.relatedTargetFolios,
              it.id,
              response.data.data.folios.filter(folio => folio.locked !== true && isEmpty(folio.invoiceNumber) && folio.id !== this.folioId && folio.hasOpenTransactions),
            );
          });
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  @import '~styles/import';

  .hm-table /deep/ .hm-table__content {
    grid-template-columns: 5.5rem repeat(var(--table-columns-1), auto);
  }

</style>



// WEBPACK FOOTER //
// src/components/lib/folios/TransactionTransferView.vue